export default __webpack_public_path__ + "static/media/business-planning-banner.def135ce.png";